// Libs
import React, { useContext } from 'react';
import { useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
// Components
import { Span } from 'components';
// Context
import { ElementViewBuilderContext } from 'core/context';
// Config
import { ElementViewBuilderConfig } from 'core/ElementViewBuilder';
// Selectors
import { selectSelectedSubModule } from 'components/Modules/selectors';
import MODULE_KEYWORDS from 'components/Modules/keywords';

const PaycutName = ({ elementId, paycutName, disableOverview }) => {
	const { setElementView } = useContext(ElementViewBuilderContext);
	const elementViewKeys =
		ElementViewBuilderConfig.getAuthorizedElementViewKeys();
	const { pathname } = useLocation();
	const selectedSubModule = useSelector(selectSelectedSubModule);
	const { BILLINGS } = MODULE_KEYWORDS.MODULES.ITEMS.KEYS;
	const isInvoice =
		pathname.includes('/invoices') ||
		selectedSubModule?.key === BILLINGS.INVOICES;

	const handleOpenOverview = e => {
		e.stopPropagation();
		setElementView({
			elementViewKey:
				elementViewKeys.BILLING_PAYMENT_PAYCUT_DETAILS_REQUEST_ELEMENT,
			elementId,
			isInvoice,
		});
	};

	if (disableOverview) return <Span>{paycutName}</Span>;

	return <Span onClick={handleOpenOverview}>{paycutName}</Span>;
};
export default PaycutName;
